import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AppStateManager;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import formatLegacyFlippers from '../../utils/formatLegacyFlippers';
import getOptionalValue from '../../utils/getOptionalValue';
import isSSR from '../../utils/isSSR';
import { AppState, AppStateEvent, NavigationState } from '../constants';
import StateManager from './StateManager';
import { detectDevice } from '../../utils/akamaiCookies/device-api';
var AppStateManager = function (_StateManager) {
  function AppStateManager() {
    var _this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$instanceId = _ref.instanceId,
      instanceId = _ref$instanceId === void 0 ? AppStateManager.InstanceId : _ref$instanceId,
      _ref$pathToData = _ref.pathToData,
      pathToData = _ref$pathToData === void 0 ? '__APP_STATE__' : _ref$pathToData,
      _cookies = _ref.cookies,
      _enabledFlippers = _ref.enabledFlippers,
      _isBot = _ref.isBot;
    _classCallCheck(this, AppStateManager);
    _this = _callSuper(this, AppStateManager, [{
      instanceId: instanceId,
      pathToData: pathToData
    }]);
    _defineProperty(_this, "pathToData", '__APP_STATE__');
    _defineProperty(_this, "state", {});
    _defineProperty(_this, "setters", {});
    _defineProperty(_this, "updateDerivedValues", function () {
      var _this$state;
      var triggerChangeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var enabledFlippers = (_this$state = _this.state) === null || _this$state === void 0 || (_this$state = _this$state[AppState.EnabledFlippers]) === null || _this$state === void 0 ? void 0 : _this$state.enabledFlippers;
      _this.state[AppState.Flippers] = enabledFlippers ? formatLegacyFlippers(enabledFlippers) : {};
      if (triggerChangeEvent) {
        _this.emit(AppStateEvent.Change(AppState.Flippers));
      }
    });
    _defineProperty(_this, "getInitialAppState", function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        enabledFlippers = _ref2.enabledFlippers,
        isBot = _ref2.isBot,
        cookies = _ref2.cookies;
      var deviceData = detectDevice(cookies);
      return {
        pageNavigation: {
          timestamp: "".concat(Date.now()),
          pageinstance: (Math.random() * 10000000000000000).toFixed(0)
        },
        enabledFlippers: {
          fromSSR: !!enabledFlippers,
          enabledFlippers: enabledFlippers
        },
        isBot: {
          isBot: isBot
        },
        device: {
          deviceData: deviceData,
          isDesktop: deviceData && deviceData.isdesktop
        },
        navigationState: NavigationState.Complete
      };
    });
    _defineProperty(_this, "getSerializableData", function () {
      var state = _objectSpread({}, _this.state);
      delete state.triggeredPageReady;
      delete state.flippers;
      return state;
    });
    _defineProperty(_this, "getSerializedScript", function () {
      return "\n    window.getApplicationState = function(name) { return window.".concat(_this.pathToData, "[name]; }\n    window.getEnabledFlippers = function() { return window.getApplicationState('enabledFlippers'); };\n    window.getPageNavigation = function() { return window.getApplicationState('pageNavigation'); };\n    window.getTriggeredPageReady = function() { return window.getApplicationState('triggeredPageReady'); };\n    window.getIsBot = function() { return window.getApplicationState('isBot'); };\n  ");
    });
    _defineProperty(_this, "getSetter", function (name) {
      if (!_this.setters[name]) {
        _this.setters[name] = function (value) {
          _this.set(name, value);
        };
      }
      return _this.setters[name];
    });
    _defineProperty(_this, "set", function (name, value) {
      if (_this.state[name] !== value) {
        _this.state[name] = value;
        if (name === AppState.EnabledFlippers) {
          _this.updateDerivedValues(true);
        }
        _this.emit(AppStateEvent.Change(name));
      }
    });
    _defineProperty(_this, "get", function (name) {
      return _this.state[name];
    });
    _defineProperty(_this, "waitForValue", function (valueName) {
      return new Promise(function (resolve) {
        if (_this.get(valueName)) {
          resolve();
        }
        var _onValueChange = function onValueChange() {
          if (_this.get(valueName)) {
            _this.off(AppStateEvent.Change(valueName), _onValueChange);
            resolve();
          }
        };
        _this.on(AppStateEvent.Change(valueName), _onValueChange);
      });
    });
    if (isSSR()) {
      _this.state = _this.getInitialAppState({
        enabledFlippers: _enabledFlippers,
        isBot: _isBot,
        cookies: _cookies
      });
    } else {
      _this.state = getOptionalValue(window, _this.pathToData) || _this.getInitialAppState({
        enabledFlippers: _enabledFlippers,
        isBot: _isBot,
        cookies: _cookies
      });
      window.getApplicationState = function (name) {
        return _this.state[name];
      };
      window.getEnabledFlippers = function () {
        return _this.state.enabledFlippers;
      };
      window.getPageNavigation = function () {
        return _this.state.pageNavigation;
      };
      window.getTriggeredPageReady = function () {
        return _this.state.triggeredPageReady;
      };
      window.getIsBot = function () {
        return _this.state.isBot;
      };
    }
    _this.updateDerivedValues();
    return _this;
  }
  _inherits(AppStateManager, _StateManager);
  return _createClass(AppStateManager);
}(StateManager);
_AppStateManager = AppStateManager;
_defineProperty(AppStateManager, "InstanceId", 'AppStateManager');
_defineProperty(AppStateManager, "getInstance", function (context) {
  return StateManager.getInstance(_AppStateManager, context);
});
export { AppStateManager as default };